import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { sections } from '../data/sections';
import { technicalDomains } from '../data/technical';
const section = sections[7];
export function TechnicalMastery() {
  return <div data-id="element-291" data-mp="1am712s10ynfb">
      <PageHeader section={section} intro="The industrial technologies and governance systems Janice can interrogate directly, without relying on a translator in the room." data-id="element-292" data-mp="1amqh237471qp" />

      <div className="mt-12 grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-4" data-id="element-293" data-mp="1jkajhfgpr42w">
        {technicalDomains.map(domain => <article key={domain.name} className="flex h-full flex-col bg-white p-8" data-id="element-294" data-mp="1tcg8qhfkz7ee">
            <span className="font-serif text-sm text-gold-dark" data-id="element-295" data-mp="1od3om4g3gefi">
              {domain.index}
            </span>
            <h2 className="mt-4 font-serif text-xl leading-snug text-navy" data-id="element-296" data-mp="22c3d9c3lwtbo">
              {domain.name}
            </h2>
            <p className="mt-3 text-[13px] leading-relaxed text-slateink-light" data-id="element-297" data-mp="1yc1cr69ly5xz">
              {domain.description}
            </p>
            <ul className="mt-auto space-y-2 pt-6" data-id="element-298" data-mp="3kknbmgt5hgha">
              {domain.systems.map(system => <li key={system} className="flex items-start gap-2.5 border-t border-slate-100 pt-2 text-[12px] font-medium leading-snug text-slateink" data-id="element-299" data-mp="3om8ldtae1en9">
                  <span aria-hidden="true" className="mt-1.5 h-1 w-1 shrink-0 bg-gold" data-id="element-300" data-mp="2al4xkx9go58" />
                  {system}
                </li>)}
            </ul>
          </article>)}
      </div>
    </div>;
}